import type { UmbracoRichText, UmbracoRichTextElement } from '@gro-up/types'
import { isUmbracoRichText } from '@gro-up/ui/utils'

/**
 * Convert Umbraco RichText to raw HTML string
 * Useful for v-html directives where Vue component rendering is not suitable
 */
export function useRichTextToHtml() {
  const convertElementsToHtml = (elements: UmbracoRichTextElement[]): string => {
    return elements
      .map(el => {
        if (el.tag === '#text') {
          return el.text || ''
        }
        if (el.tag === 'br') {
          return '<br>'
        }
        if (el.tag === 'p') {
          return convertElementsToHtml(el.elements)
        }
        if (el.tag === 'span') {
          const attrs = el.attributes
            ? Object.entries(el.attributes)
                .map(([key, value]) => `${key}="${value}"`)
                .join(' ')
            : ''
          const attrStr = attrs ? ` ${attrs}` : ''
          return `<span${attrStr}>${convertElementsToHtml(el.elements)}</span>`
        }
        if (el.tag === 'em') {
          return `<em>${convertElementsToHtml(el.elements)}</em>`
        }
        if (el.tag === 'strong') {
          return `<strong>${convertElementsToHtml(el.elements)}</strong>`
        }
        return convertElementsToHtml(el.elements || [])
      })
      .join('')
  }

  const richTextToHtml = (richText: unknown): string => {
    if (!richText || typeof richText !== 'object') {
      return String(richText || '')
    }

    if (!isUmbracoRichText(richText)) {
      return String(richText || '')
    }

    return convertElementsToHtml((richText as UmbracoRichText).elements)
  }

  return {
    richTextToHtml,
  }
}
